var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrellisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Actions") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-768",
    points: "24.2758621 28.1382175 28.137931 32 32 28.1382175 28.137931 24.2758621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-769",
    points: "24.2758621 15.9997135 28.137931 19.862069 32 15.9997135 28.137931 12.137931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-770",
    points: "4.51638726e-12 28.1382175 3.86235545 32 7.72413793 28.1382175 3.86235545 24.2758621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-771",
    points: "4.51638726e-12 15.9997135 3.86235545 19.862069 7.72413793 15.9997135 3.86235545 12.137931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-772",
    points: "12.137931 15.9997135 16 19.862069 19.862069 15.9997135 16 12.137931"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-773",
    points: "12.137931 28.1382175 16 32 19.862069 28.1382175 16 24.2758621"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-774",
    points: "24.2758621 3.86178248 28.137931 7.72413793 32 3.86178248 28.137931 -3.10862447e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-775",
    points: "12.137931 3.86178248 16 7.72413793 19.862069 3.86178248 16 -3.10862447e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-776",
    points: "4.51638726e-12 3.86178248 3.86235545 7.72413793 7.72413793 3.86178248 3.86235545 -3.10862447e-14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrellisLogo);
export default __webpack_public_path__ + "static/media/trellis_logo.9f471d530094d7111203c70f87ae23ab.svg";
export { ForwardRef as ReactComponent };